module.exports = __webpack_public_path__ + "static/media/icons-09.e712da64.png";